import {
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  GET_EMPLOYEE_INFO,
  SET_USER_DATA,
  UPDATE_USER_MODAL,
  SET_USER_FAIL,
  GET_ALL_USER,
  ERROR_USER_FAIL
} from "../actions/actionTypes"

const initialState = {
  loggedIn: false,
  userData: [],
  userModal: {},
  errorMsg: "",
  m_userData: [],
  usererrorMsg: "",
}

function UserRedux(state = initialState, action) {
  switch (action.type) {
    case LOGIN_START:
      return {
        ...state,
        loggingIn: false
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true
      }
    case LOGIN_FAIL:
      return {
        loggedIn: false
      }
    case LOGOUT:
      return {
        loggingIn: false
      }
    case GET_EMPLOYEE_INFO:
      return {
        ...state
      }
    case SET_USER_DATA:
      return {
        ...state,
        userData: action.payload,
        errorMsg: ""
      }
    case UPDATE_USER_MODAL:
      // console.log("UPDATE_USER_MODAL", action)
      return {
        ...state,
        userModal: action.data
      }
    case SET_USER_FAIL:
      return {
        ...state,
        errorMsg: action.data
      }
    case GET_ALL_USER:
      return {
        ...state,
        userData: action.payload,
      }
    case ERROR_USER_FAIL:
      return {
        ...state,
        usererrorMsg: action.payload,
      }
    default:
      return state;
  }
}

export default UserRedux
